export default __webpack_public_path__ + "static/costume_m_pantalon-7014d2a667da043a460d19f363268a48.png";